export default __webpack_public_path__ + "static/media/Nursery.6a2e3e9f.png";